import { useAtomValue } from 'jotai';

import { useBuildFormContext } from '../../../form/schema';
import { similarSlotAtom } from '../stores/questionCardAi.atoms';

/**
 * 카드 목록에 보이는 문항 번호(1부터). 유사 문제 대기·실패 카드는 폼 문항이 아니지만 원본
 * 바로 아래 한 자리를 차지하므로, 그 아래 실제 카드들의 번호를 하나씩 민다 — 안 밀면 대기
 * 카드와 바로 아래 카드가 같은 번호를 단다.
 *
 * 원본 순서는 렌더 시점 폼 값으로 읽는다. 재정렬·삽입·삭제는 index 가 바뀌어 다시 그려지고,
 * 슬롯이 열리고 닫히는 것은 similarSlotAtom 구독으로 다시 그려진다.
 */
export const useQuizDisplayNumber = (index: number): number => {
  const slots = useAtomValue(similarSlotAtom);
  const { getValues } = useBuildFormContext();

  const sourceIds = Object.keys(slots);
  if (sourceIds.length === 0) return index + 1;

  const pendingAbove = getValues('quizList')
    .slice(0, index)
    .filter(quiz => sourceIds.includes(quiz.id)).length;
  return index + 1 + pendingAbove;
};
